// @flow

import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import CustomEvent from 'custom-event';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';

class Share extends PureComponent {
  static defaultProps = {
    appNakedDomain: '',
    appDomain: '',
    location: {
      pathname: '',
    },
  };

  static propTypes = {
    appNakedDomain: PropTypes.string.isRequired,
    appDomain: PropTypes.string.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }),
  };

  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };
  }

  componentDidMount() {
    const clipboard = new Clipboard(this.button, {
      text: () => this.snippet.href,
    });

    clipboard.on('success', event => {
      event.clearSelection();
      this.setCopied();
    });

    clipboard.on('error', () => {
      global.alert('There was an error copying the URL.');
    });

    this.clipboard = clipboard;
  }

  componentWillUnmount() {
    this.clipboard.destroy();
  }

  setCopyReady() {
    this.setState({
      copied: false,
    });
  }

  setCopied() {
    this.setState({
      copied: true,
    });
  }

  closeModal() {
    global.dispatchEvent(new CustomEvent('closeModal'));

    // Reset copy.
    this.setCopyReady();
  }

  /* eslint-disable react/jsx-no-bind */
  render() {
    const { location } = this.props;
    const copyText = this.state.copied ? 'Copied!' : 'Copy';
    const copyClass = this.state.copied ? 'is-disabled' : 'btn--copy';

    let url = this.props.appDomain;
    let prettyUrl = this.props.appNakedDomain;

    // Append the path name if this is not the home page.
    if (location.pathname !== '/') {
      url += location.pathname;
      prettyUrl += location.pathname;
    }

    return (
      <div
        id="share"
        className="site-lightbox__modal site-lightbox__modal--share centered center center--both"
      >
        <h3 className="h4 theme--dark-blue">Share</h3>
        <ul className="list icon-grid links links--aqua">
          <li className="list__item icon-grid__item">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                url,
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="svg-wrapper icon"
            >
              <svg
                role="img"
                aria-labelledby="site-lightbox-share-facebook"
                focusable="false"
              >
                <title id="site-lightbox-share-facebook">
                  Share on Facebook
                </title>
                <use xlinkHref="#icon-facebook" />
              </svg>
            </a>
          </li>
          <li className="list__item icon-grid__item">
            <a
              href={`https://twitter.com/intent/tweet/?url=${encodeURIComponent(
                url,
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="svg-wrapper icon"
            >
              <svg
                role="img"
                aria-labelledby="site-lightbox-share-twitter"
                focusable="false"
              >
                <title id="site-lightbox-share-twitter">Share on Twitter</title>
                <use xlinkHref="#icon-twitter" />
              </svg>
            </a>
          </li>
          <li className="list__item icon-grid__item">
            <a
              href={`mailto:?subject=Ferguson%20Voices&body=${encodeURIComponent(
                url,
              )}`}
              className="svg-wrapper icon"
            >
              <svg
                role="img"
                aria-labelledby="site-lightbox-share-email"
                focusable="false"
              >
                <title id="site-lightbox-share-email">Share via Email</title>
                <use xlinkHref="#icon-email" />
              </svg>
            </a>
          </li>
        </ul>
        <p className="h3 h3--medium theme--dark-blue break-word">
          <a
            ref={ref => {
              this.snippet = ref;
            }}
            href={url}
            className="block"
          >
            {prettyUrl}
          </a>
        </p>
        <p className="double-spaced theme--aqua">
          <button
            ref={ref => {
              this.button = ref;
            }}
            className={`btn btn--default btn--icon-left btn--outline ${copyClass}`}
            onMouseDown={event => {
              // Prevent focus.
              event.preventDefault();
            }}
          >
            <svg aria-hidden="true" className="icon--small" focusable="false">
              <use xlinkHref="#icon-permalink" />
            </svg>
            <span className="theme--dark-blue">
              {copyText}
            </span>
          </button>
        </p>
        <div className="links links--aqua">
          <button
            className="btn btn--default btn--icon-left"
            onClick={this.closeModal.bind(this)}
          >
            <svg aria-hidden="true" className="icon--small" focusable="false">
              <use xlinkHref="#icon-close-circled" />
            </svg>
            <span>Close</span>
          </button>
        </div>
      </div>
    );
  }
  /* eslint-enable react/jsx-no-bind */
}

export default withRouter(Share);



// WEBPACK FOOTER //
// ./screens/App/components/Share/index.js